import { render } from "./IconItemCategoryRestaurant.vue?vue&type=template&id=4d66a022"
import script from "./IconItemCategoryRestaurant.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryRestaurant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__